import type { PersonProfile } from '@openeducation/oe-it-shared-types';
import { useMemo } from 'react';

import { usePendingFeedbacks } from './use-pending-feedbacks';

type StudentFeedbackProps = {
  teacherProfile: PersonProfile | null;
  studentId: number;
  classroomId: number;
};
export const useLiveClassPendingFeedback = ({
  teacherProfile,
  studentId,
  classroomId,
}: StudentFeedbackProps) => {
  const {
    pendingFeedbacks,
    isLoadingPendingFeedbacks,
    isErrorPendingFeedbacks,
    reFetchPendingFeedbacks,
  } = usePendingFeedbacks({ teacherProfile });

  const pendingFeedback = useMemo(
    () =>
      studentId && pendingFeedbacks && pendingFeedbacks.length
        ? pendingFeedbacks.find(
            ({ studentId: stId, classroomId: classId }) =>
              stId === studentId && classId === classroomId
          )
        : undefined,
    [pendingFeedbacks, studentId, classroomId]
  );

  return {
    pendingFeedback,
    isLoadingPendingFeedback: isLoadingPendingFeedbacks,
    isErrorPendingFeedback: isErrorPendingFeedbacks,
    reFetchPendingFeedback: reFetchPendingFeedbacks,
  };
};
